import { HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { combineUrl } from '../utilities/utilities';
export class RemoteExecutionLiveUpdatesService {
    constructor(accessTokenFactory, logger, options) {
        this.accessTokenFactory = accessTokenFactory;
        this.logger = logger;
        this.options = options;
        this.buildConnection();
    }
    static create(accessTokenFactory, logger, options) {
        return new RemoteExecutionLiveUpdatesService(accessTokenFactory, logger, options);
    }
    /** Starts the Remote Execution live updates service. */
    async start() {
        if (!this.connection) {
            throw new Error('Remote Execution live updates service is not initialized.');
        }
        try {
            await this.connection.start();
            this.logger.logInformation('Remote Execution live updates connection has been successfully established.');
        }
        catch (error) {
            this.logger.logError(`Remote Execution live updates service has failed to start: ${error}`);
            throw error;
        }
    }
    /** Stops the Remote Execution live updates service. */
    async stop() {
        if (!this.connection) {
            throw new Error('Remote Execution live updates service is not initialized.');
        }
        try {
            await this.connection.stop();
            this.logger.logInformation('Remote Execution live updates service has been successfully terminated.');
        }
        catch (error) {
            this.logger.logError(`Remote Execution live updates service termination has failed: ${error}`);
            throw error;
        }
    }
    /** Registers a handler that will be invoked when the hub method with the specified method name is invoked. */
    on(...parameters) {
        if (!this.connection) {
            throw new Error('Remote Execution live updates service is not initialized.');
        }
        const [methodName, handler] = parameters;
        this.connection.on(methodName, handler);
    }
    /** Removes the specified handler for the specified hub method. */
    off(...parameters) {
        if (!this.connection) {
            throw new Error('Remote Execution live updates service is not initialized.');
        }
        const [methodName, handler] = parameters;
        this.connection.off(methodName, handler);
    }
    buildConnection() {
        var _a, _b, _c;
        if (((_a = this.connection) === null || _a === void 0 ? void 0 : _a.state) === HubConnectionState.Connected ||
            ((_b = this.connection) === null || _b === void 0 ? void 0 : _b.state) === HubConnectionState.Connecting ||
            ((_c = this.connection) === null || _c === void 0 ? void 0 : _c.state) === HubConnectionState.Reconnecting) {
            return;
        }
        const { remoteExecutionFrontendApiUrl, logLevel } = this.options;
        this.connection = new HubConnectionBuilder()
            .withUrl(combineUrl(remoteExecutionFrontendApiUrl, 'runs'), {
            accessTokenFactory: this.accessTokenFactory
        })
            .withAutomaticReconnect()
            .configureLogging(logLevel !== null && logLevel !== void 0 ? logLevel : LogLevel.Information)
            .build();
        this.connection.onreconnected(connectionId => this.logger.logInformation(`Reconnected with connectionId: ${connectionId}`));
    }
}
